import {ReactNode} from "react";
import {css} from "@panda/css";
import {motion, useReducedMotion} from "framer-motion";

interface IProps {
    children: ReactNode;
}

export function TinderMultiLeadSwipeCard({children}: IProps) {
    const shouldReduceMotion = useReducedMotion();

    return (
        <motion.div
            className={swipeCardStyle}
            initial={{opacity: 0}}
            animate={{opacity: 1}}
            exit={shouldReduceMotion ? {opacity: 0} : {opacity: 0, scale: 1.3, filter: "blur(10px)"}}
            transition={{
                duration: shouldReduceMotion ? 0.18 : 0.4,
                ease: [0.4, 0, 0.2, 1],
                opacity: {duration: shouldReduceMotion ? 0.18 : 0.26}
            }}
        >
            {children}
        </motion.div>
    );
}

const swipeCardStyle = css({
    position: "relative",
    zIndex: 1,
    transformOrigin: "center",
    willChange: "transform, filter"
});
import {ReactNode} from "react";
import {css} from "@panda/css";
import {motion, useReducedMotion} from "framer-motion";

interface IProps {
    children: ReactNode;
}

export function TinderMultiLeadSwipeCard({children}: IProps) {
    const shouldReduceMotion = useReducedMotion();

    return (
        <motion.div
            className={swipeCardStyle}
            initial={{opacity: 0}}
            animate={{opacity: 1}}
            exit={shouldReduceMotion ? {opacity: 0} : {opacity: 0, scale: 1.3, filter: "blur(10px)"}}
            transition={{
                duration: shouldReduceMotion ? 0.18 : 0.4,
                ease: [0.4, 0, 0.2, 1],
                opacity: {duration: shouldReduceMotion ? 0.18 : 0.26}
            }}
        >
            {children}
        </motion.div>
    );
}

const swipeCardStyle = css({
    position: "relative",
    zIndex: 1,
    transformOrigin: "center",
    willChange: "transform, filter"
});
